import { Campaign } from '~/lib/types/Campaign'

export const PaymentMethodKind = {
  CreditCard: 'credit_card',
  Invoice: 'invoice',
  Mfkessai: 'mfkessai',
  CreditCardGmopg: 'credit_card_gmopg',
} as const

export type PaymentMethodKind = (typeof PaymentMethodKind)[keyof typeof PaymentMethodKind]

export type AdvAccount = {
  id: number
  status: string | null
  companyName: string | null
  companyNameFurigana: string | null
  companyUrl: string | null
  representativeName: string | null
  postalcode: string | null
  pref: string | null
  city: string | null
  address1: string | null
  address2: string | null
  paymentType: PaymentMethodKind | null
  isRetrievePayjpCustomer: boolean
  // TODO: フィールドの有無/命名は仮なのでバックエンドの実装が確定したら必要に応じて修正する
  isRetrieveGmopgCustomer: boolean
  referralAgencyId: number | null
  referralAgencyContractType: number | null
  route: number | null
  isProxied?: boolean
}

export type CardList = {
  cards: Cards
  defaultCard: string
}

type Cards = {
  data: Card[]
}

export type CardBrand = 'Visa' | 'MasterCard' | 'JCB' | 'American Express' | 'Diners Club' | 'Discover'

export type Card = {
  id: string
  last4: string
  brand: CardBrand
  expMonth: number
  expYear: number
}

export type PaymentHistory = {
  charges: Charge
  next: number
  prev: number
}

export type Charge = {
  data?: ChargeData[]
  count: number
  hasMore: boolean
  object: string
  url: string
}

export type ChargeData = {
  id: string
  amount: number
  card: Card
  capturedAt: number
  created: number
  failureCode: string | null
}

export type CardEditUrl = {
  url: string
}

/**
 * PayJPのエラーコード（代表的なもののみ）
 * @see https://pay.jp/docs/api/#error
 */
export const PAY_JP_ERROR_CODES = {
  invalid_expiry_month: '不正な有効期限月のカードが使用されました',
  invalid_expiry_year: '不正な有効期限年のカードが使用されました',
  expired_card: '有効期限切れのカードが使用されました',
  card_declined: 'カード会社によって拒否されたカードが使用されました',
  card_flagged: '一時的に制限されているカードが使用されました',
  processing_error: '決済ネットワーク上でエラーが発生しました',
  missing_card: '不正なカードが使用されました',
  unacceptable_brand: '対象のカードブランドが許可されていません',
  invalid_id: '不正なIDです',
  invalid_card: '不正なカードが使用されました',
} as const

export const isPayJpErrorCode = (paymentMethod: PaymentMethodKind | null, code: string | null) => {
  return paymentMethod === PaymentMethodKind.CreditCard && code != null
}

/**
 * GMOPGのエラーコード（代表的なもののみ）
 * @see https://static.mul-pay.jp/doc/openapi-type/#tag/errors
 */
export const GMOPG_ERROR_CODES = {
  operation_aborted_by_user: 'お客様の操作により決済手続きが中止されました',
  card_declined: 'カード起因のエラーにより、リクエストが拒否されました',
  insufficient_balance: '残高が不足しているため、リクエストが拒否されました',
  amount_limit_exceeded: '上限金額を超過しているため、リクエストが拒否されました',
  processing_failure: '決済事業者からエラーが返りました',
}

export const isGmopgErrorCode = (paymentMethod: PaymentMethodKind | null, code: string | null) => {
  return paymentMethod === PaymentMethodKind.CreditCardGmopg && code != null
}

export type AccountReport = {
  numAgreement: number
  offerFixCount: number
  offerFixAmount: number
  campaign: Campaign
  unsettledCount: number
  unsettledAmount: number
}

export type SummaryReports = {
  summaryNumAgreement: number
  summaryFixedCount: number
  summaryFixedAmount: number
  summaryUnsettledCount: number
  summaryUnsettledAmount: number
}
